<template>
    <basic-container id="warehouserequisition">
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
                   <template slot="searchMenu">

                        <!-- <el-button size="small" @click="searchReset()">重 置</el-button> -->
                        <div style="display: inline-block; margin: 0 20px 0 40px">汇总金额</div>

                         <moneyInput v-model="money"  disabled  style= "display: inline-block; width: 150px"  />
                    </template>
                    <template slot-scope="scope" slot="requisitionAmount">
                    <div class="money"><span>{{tool.money_format_allowvoid(scope.row.requisitionAmount)  }}</span></div>
                    </template>
            <template slot="menuLeft" slot-scope="scope">
                <el-button type="primary"
                           size="small"
                           @click="applyFor">申请
                </el-button>
            </template>
            <template slot="menu" slot-scope="scope">
                <el-button type="text"
                           size="small"
                           v-if="permissionList.viewBtn"
                           icon="el-icon-view"
                           @click="openViewDialog(scope.row,permissionList.auditBtn)">查看
                </el-button>
                <el-button type="text"
                           size="small"
                           icon="el-icon-document"
                            v-if="scope.row.requisitionStatus==6
                            ||scope.row.requisitionStatus==7
                            || scope.row.requisitionStatus==5
                            "
                           @click="jumpOutbound(scope.row)">出库单
                </el-button>

                <el-button type="text"
                           size="small"
                             v-if="scope.row.requisitionStatus==1"
                           icon="el-icon-edit"
                           @click="openEditDialog(scope.row)">编辑

                </el-button>
            </template>
            <template slot="projectIdSearch">
                 <el-select v-model="searchForm.projectId" placeholder="项目名称">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="warehouseIdSearch">
                <el-select v-model="searchForm.warehouseId" placeholder="仓库名称">
                    <el-option
                        v-for="item in warehouseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="requisitionTime" slot-scope="scope">
                {{dayjs(scope.row.requisitionTime).format('YYYY-MM-DD HH:mm:ss')}}
            </template>
            <template slot="requisitionTimeSearch" slot-scope="scope">
                <el-date-picker
                    v-model="valuetime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间">
                </el-date-picker>
            </template>
            <template slot="moneySearch" slot-scope="scope">
                <el-input v-model="money" disabled></el-input>
            </template>
            <template slot="userNameSearch" slot-scope="scope">
                 <el-select
                    v-model="searchForm.requisitionUser"
                    filterable
                    placeholder="申请人"
                    >
                    <el-option
                    v-for="item in userlist"
                    :key="item.id"
                    :label="item.realNameAndPhone"
                    :value="item.id">
                    </el-option>
                </el-select>
            </template>
        </avue-crud>
        <recipientsFrom ref="recipientsFrom" @onLoad="onLoad"></recipientsFrom>
    </basic-container>
</template>

<script>
    import {checkPath} from '@/api/user'
    import {
        add,
        getDetail,
        getList,
        remove,
        update,
        getUserlist,
        getPriceSum,
    } from "@/api/warehouseRequisition/warehouserequisition";
    import {mapGetters} from "vuex";
    import recipientsFrom from "./recipients-from.vue";
    import {getProjectList1} from "@/api/crmedical/project/project";
    import {
        getProjectList,
        getWarehouseList,
        getDict,
        } from "@/api/crmedical/warehouse/index.js";
    export default {
        components:{
            recipientsFrom
        },

        data() {
            return {
                form: {},
                valuetime:'',
                query: {},
                money:0,
                loading: false,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                onloadFlag:false,//为了避免第一次请求必须在projecid赋值后进行
                selectionList: [],
                searchForm:{
                    projectId:'',
                    warehouseId:'',
                    people:''
                },
                projectList:[],//项目名称
                warehouseList:[],//仓库名称
                statusList:[],//状态
                option: {
                    height: 'auto',
                    stripe:true,
                    dialogClickModal:false,
                    calcHeight: 30,
                    tip: false,
                    addBtn:false,
                    searchShow: true,
                    searchMenuSpan: 10,
                    border: true,
                    index: true,
                    emptyBtn:true,
                    viewBtn: false,
                    selection: false,
                    align: 'left',
                    column: [

                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    dicUrl: '/api/v4ward/project/getProjectList',
                                    search: true,
                                    type:'select',
                                    searchslot:true,
                                    dataType: 'string',
                                    dicData:[],
                                    props:{
                                        label:'name',
                                        value:'id'
                                    },
                                    value:'',
                                    rules: [{
                                        required: true,
                                        message: "请选择项目",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "领用单号",
                                    prop: "requisitionNo",

                                },
                                {
                                    label: "仓库名称",
                                    prop: "warehouseName",

                                },

                                {
                                    label: "仓库名称",
                                    prop: "warehouseId",
                                    search: true,
                                    hide:true,
                                    searchslot:true,
                                    type:'select',
                                    rules: [{
                                        required: true,
                                        message: "请选择仓库",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "领用科室",
                                    prop: "deptName",
                                    type:'select',
                                    rules: [{
                                        required: true,
                                        message: "请输入货品id",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "申请人",
                                    prop: "userNamePhone",
                                },
                                 {
                                    label: "申请人",
                                    prop: "requisitionUser",
                                    // searchslot:true,
                                    type:'select',
                                    searchFilterable:true,
                                    filterable:true,
                                    hide:true,
                                    props:{
                                        label: 'realNameAndPhone',
                                        value: 'id'
                                    },
                                    search: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入领用数",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "申请时间",
                                    prop: "requisitionTime",
                                    search:true,
                                    slot:true,
                                    type: 'datetimerange',
                                    searchslot:true,
                                    rangeSeparator:"至",

                                },
                                {
                                    label: "申请总金额",
                                    prop: "requisitionAmount",
                                    align: 'right',
                                    rules: [{
                                        required: true,
                                        message: "请输入货品单价",
                                        trigger: "change"
                                    }],
                                    slot:true
                                },
                                {
                                    label: "状态",
                                    prop: "requisitionStatus",
                                    search: true,
                                    type:'select',
                                    dataType:'number',
                                    dicUrl:'/api/blade-system/dict/dictionary?code=warehouse_requisition_status',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择状态",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "领用单号",
                                    prop: "requisitionNo2",
                                    search: true,
                                    hide:true,
                                    maxlength: 21,
                                    showWordLimit: true,

                                },
                                              ]
                },
                data: [],
                userlist: [],
        value: [],
        list: [],
        loading: false,

      }

        },
        // mounted() {
        //     this.list = this.states.map(item => {
        //         return { value: `value:${item}`, label: `label:${item}` };
        //     });
        // },
        created() {
                this.fetchData();
                // setTimeout(()=>{
                //     window.onresize = ()=>{
                //         this.$refs.crud.$refs.table.doLayout();
                //     }
                // })
                this.$nextTick(() => {
                    setTimeout(()=>{
                      this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{

                            if(this.option.height == this.bodyHeight - 368){
                              this.option.height = this.bodyHeight - 250
                            }else{
                              this.option.height = this.bodyHeight - 368;
                            }
                            this.$refs.crud.getTableHeight();
                        });
                      })

                });
                this.option.height = this.bodyHeight - 368;
        },
        computed: {
            ...mapGetters(["permission",'userInfo']),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.warehouserequisitionconsumable_add, false),
                    viewBtn: this.vaildData(this.permission.warehouserequisitionconsumable_view, true),
                    delBtn: this.vaildData(this.permission.warehouserequisitionconsumable_delete, false),
                    editBtn: this.vaildData(this.permission.warehouserequisitionconsumable_edit, false),
                    auditBtn: this.vaildData(this.permission.warehouserequisitionconsumable_audit, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        watch:{
            'searchForm.projectId'(){
                console.log(1212)
                this.getWarehouseList();
            }
        },
        methods: {
            // 跳转出库记录
            jumpOutbound(row){
                checkPath({
                    path:'/crmedical/warehouse/supplies-recipients/outbound-record/outbound-record'
                }).then(({data})=>{
                    if(data.data){
                        this.$router.push({
                            path:'/crmedical/warehouse/supplies-recipients/outbound-record/outbound-record',
                            query:{
                                requisitionNo:row.requisitionNo,
                                projectId:row.projectId,
                                warehouseId:row.warehouseId,
                            }
                        })
                    }else{
                        this.$message.error('您无浏览此页面的权限！');
                    }
                })

                // this.$message({
                //         message: '该功能暂未开放',
                //         type: 'warning'
                // });
            },
             // 获取仓库列表
            getWarehouseList(){
                    this.searchForm.warehouseId = '';
                    getWarehouseList({projectId:this.searchForm.projectId}).then(res=>{
                            this.warehouseList = res.data;
                            let warehouseIdColumn  = this.findObject(this.option.column, "warehouseId");
                            warehouseIdColumn.dicData = this.warehouseList
                            this.searchForm.warehouseId=this.warehouseList[0]?this.warehouseList[0].id:'';
                    })
            },
            async fetchData() {
                this.pageLoading = true;

                let userId= this.userInfo.user_id

                getUserlist().then(res=>{
                    this.userlist = res.data;
                    let requisitionUsercolumn  = this.findObject(this.option.column, "requisitionUser");
                    requisitionUsercolumn.dicData = this.userlist;
                    console.log(55655555)
                    console.log(this.userlist)
                });
                // getDict({code:'warehouse_requisition_status'}).then(res=>{
                //     this.statusList = res.data;
                //     let projeCtcolumn  = this.findObject(this.option.column, "projectId");
                //     projeCtcolumn.dicData = this.projectList;
                //     status
                // })
                try {
                    //projectList
                    const resProjectList = await getProjectList();
                    this.projectList = resProjectList.data;
                    // let projeCtcolumn  = this.findObject(this.option.column, "projectId");
                    // projeCtcolumn.dicData = this.projectList;
                    // projeCtcolumn.value = this.projectList[0].id;
                    // console.log(projeCtcolumn)

                    this.searchForm.projectId = this.projectList[0]? this.projectList[0].id:'';

                    //warehouseList
                    const resWarehouseList = await getWarehouseList({
                        projectId: this.searchForm.projectId,
                    });
                    this.warehouseList = resWarehouseList.data;
                    this.searchForm.warehouseId = this.warehouseList[0]? this.warehouseList[0].id: "";
                    this.onloadFlag = true;
                    this.onLoad();
                    //type && status
                    const dicts = await Promise.all([
                        getDict({ code: "warehouse_inbound_type" }),
                        getDict({ code: "inbound_status" }),
                    ]);
                    this.warehouseInboundTypeList = dicts[0].data;
                    this.searchForm.type = this.warehouseInboundTypeList[0].dictKey;
                    this.inboundStatusList = dicts[1].data;
                    this.searchForm.inboundStatus = this.inboundStatusList[0].dictKey;
                } catch (err) {
                    console.log("err==>", err);
                }
                this.pageLoading = false;
                },
            // 打开申请表单 新增
            applyFor(){
                let dicData = {
                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                this.$refs.recipientsFrom.openDialog({type:'add',dicData:dicData});
            },
            // 打开编辑弹窗
            openEditDialog(row){
                console.log(row)
                let dicData = {

                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                this.$refs.recipientsFrom.openDialog({type:'edit',dicData:dicData,data:row,});
            },
            // 打开查看弹窗
            openViewDialog(row,auditBtn){
                // console.log(auditBtn)
                // return
                let dicData = {

                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                this.$refs.recipientsFrom.openDialog({type:'view',dicData:dicData,data:row,auditBtn:auditBtn,});
            },

            // 申请人模糊搜索
             remoteMethod(query) {
                if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter(item => {
                    return item.label.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
                } else {
                this.options = [];
                }
            },
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                } else if ("add" === type) {
                    this.cleanForm();
                }
                done();
            },
            cleanForm() {
                for(let key in this.form){
                    this.form[key] = null;
                }
            },
            searchReset() {
                this.searchForm.projectId = this.projectList[0]?this.projectList[0].id:'';
                // this.searchForm.warehouseId = this.warehouseList[0]?this.warehouseList[0].id:'';
                // this.searchForm.requisitionUser = '';
                this.query.requisitionNo2 = '';
                this.query.requisitionUser = '';
                this.valuetime = ''


                this.query = {};
                this.$refs.crud.toggleSelection();
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                if(!this.onloadFlag){
                    return;
                }
                page = page || this.page;
                this.query.projectId = this.searchForm.projectId || '';
                this.query.warehouseId =  this.searchForm.warehouseId || '';
                // this.query.requisitionUser = this.searchForm.requisitionUser || '';
                this.query.requisitionNo = this.query.requisitionNo2 || '';

                if(this.valuetime){
                    this.query.timeStart = this.dayjs(this.valuetime[0]).format('YYYY-MM-DD HH:mm:ss');
                    this.query.timeEnd = this.dayjs(this.valuetime[1]).format('YYYY-MM-DD HH:mm:ss');
                }

                this.loading = true;
                console.log(this.query)
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    data.records.forEach(ele=>{
                        if(ele.userPhone){
                            ele.userNamePhone = ele.userName +'('+ ele.userPhone +')'
                        }else{
                            ele.userNamePhone = ele.userName
                        }

                    })
                    this.data = data.records;
                    this.loading = false;
                    // this.selectionClear();
                });
                getPriceSum(Object.assign({current: page.currentPage, size: page.pageSize}, this.query)).then(res=>{
                    this.money = res.data;
                })
            }
        }
    };
</script>

<style scoped>
 .money{
  text-align: right;
}
</style>
<style >
#warehouserequisition .el-table .cell{
    white-space: inherit;
  }
</style>
